{
  "familyId": "GELD-BTW",
  "questions": [
    {
      "id": "GELD-BTW-001", "familyId": "GELD-BTW", "module": "Geld", "tier": 15, "levelCode": "E8", "group": 8, "skill": "geld_toegepast", "subSkill": "geld_btw", "questionType": "multiple_choice",
      "question": "Een fietsenmaker verkoopt een fietsband voor €100 exclusief BTW. Met 21% BTW erbij, wat betaalt de klant?",
      "options": ["€121", "€21", "€79", "€100,21"], "correctAnswer": 0,
      "conceptId": "btw_excl_to_incl_21pct", "variantIndex": 1, "citoDifficulty": 0.30, "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "BTW-ONLY-TAX", "optionIndex": 1, "label": "Geeft alleen het BTW-bedrag, niet de totaalprijs" },
          { "id": "BTW-SUBTRACT", "optionIndex": 2, "label": "Trekt BTW af in plaats van erbij op te tellen" },
          { "id": "BTW-LITERAL-CENTS", "optionIndex": 3, "label": "Interpreteert 21% als €0,21 in plaats van 0,21 × prijs" }
        ]
      },
      "supportAids": [{ "type": "rule", "data": { "title": "BTW berekenen (21%)", "content": "Bereken eerst de BTW: 21% van €100 = 0,21 × €100 = €21. Tel de BTW bij de prijs: €100 + €21 = €121. De klant betaalt €121.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "stimulusAids": [],
      "feedback": { "explanationText": "De fietsenmaker berekent de prijs inclusief BTW: 21% van €100 = €21. Totaal: €100 + €21 = €121. Of sneller: €100 × 1,21 = €121.", "solutionSteps": ["BTW = 21% van €100 = 0,21 × €100 = €21", "Prijs inclusief = €100 + €21 = €121", "Of sneller: €100 × 1,21 = €121 ✓"], "distractorExplanations": { "0": "Goed! €100 + 21% BTW (€21) = €121.", "1": "€21 is alleen het BTW-bedrag, niet de totaalprijs. De klant betaalt de prijs plus de BTW: €100 + €21 = €121.", "2": "Bij 'inclusief BTW' tel je de BTW erbij op, niet eraf. €100 + €21 = €121, niet €100 − €21 = €79.", "3": "21% betekent 0,21 × de prijs. 0,21 × €100 = €21, niet €0,21." } }
    },
    {
      "id": "GELD-BTW-002", "familyId": "GELD-BTW", "module": "Geld", "tier": 15, "levelCode": "E8", "group": 8, "skill": "geld_toegepast", "subSkill": "geld_btw", "questionType": "multiple_choice",
      "question": "Een bloemist koopt bloemen voor €75 exclusief BTW. Met 9% BTW erbij, wat betaalt ze?",
      "options": ["€81,75", "€6,75", "€68,25", "€84"], "correctAnswer": 0,
      "conceptId": "btw_excl_to_incl_9pct", "variantIndex": 2, "citoDifficulty": 0.35, "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "BTW-ONLY-TAX", "optionIndex": 1, "label": "Geeft alleen het BTW-bedrag, niet de totaalprijs" },
          { "id": "BTW-SUBTRACT", "optionIndex": 2, "label": "Trekt BTW af in plaats van erbij op te tellen" },
          { "id": "BTW-FLAT-RATE", "optionIndex": 3, "label": "Interpreteert 9% als vast bedrag €9" }
        ]
      },
      "supportAids": [{ "type": "rule", "data": { "title": "BTW berekenen (9%)", "content": "Bereken eerst de BTW: 9% van €75 = 0,09 × €75 = €6,75. Tel de BTW bij de prijs: €75 + €6,75 = €81,75.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "stimulusAids": [],
      "feedback": { "explanationText": "De bloemist berekent de prijs inclusief BTW: 9% van €75 = €6,75. Totaal: €75 + €6,75 = €81,75. Of sneller: €75 × 1,09 = €81,75.", "solutionSteps": ["BTW = 9% van €75 = 0,09 × €75 = €6,75", "Prijs inclusief = €75 + €6,75 = €81,75", "Of sneller: €75 × 1,09 = €81,75 ✓"], "distractorExplanations": { "0": "Goed! €75 + 9% BTW (€6,75) = €81,75.", "1": "€6,75 is alleen het BTW-bedrag. De bloemist betaalt de prijs plus de BTW: €75 + €6,75 = €81,75.", "2": "Bij 'inclusief BTW' tel je de BTW erbij op, niet eraf. €75 + €6,75 = €81,75, niet €75 − €6,75 = €68,25.", "3": "9% van €75 is €6,75, niet €9. Onthoud: 0,09 × €75 = €6,75." } }
    },
    {
      "id": "GELD-BTW-003", "familyId": "GELD-BTW", "module": "Geld", "tier": 15, "levelCode": "E8", "group": 8, "skill": "geld_toegepast", "subSkill": "geld_btw", "questionType": "multiple_choice",
      "question": "Een elektricien stuurt een rekening van €121 inclusief 21% BTW. Wat is de prijs exclusief BTW?",
      "options": ["€100", "€96,80", "€142", "€101"], "correctAnswer": 0,
      "conceptId": "btw_incl_to_excl_21pct", "variantIndex": 3, "citoDifficulty": 0.40, "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "BTW-SUBTRACT-FROM-INCL", "optionIndex": 1, "label": "Trekt 21% van inclusief-prijs af i.p.v. delen door 1,21" },
          { "id": "BTW-ADD-INSTEAD", "optionIndex": 2, "label": "Telt BTW erbij in plaats van eruit te rekenen" },
          { "id": "BTW-SUBTRACT-FLAT", "optionIndex": 3, "label": "Trekt €21 af als vast bedrag" }
        ]
      },
      "supportAids": [{ "type": "rule", "data": { "title": "BTW terugrekenen (21%)", "content": "Bij 21% BTW is de prijs inclusief BTW 121% van de oorspronkelijke prijs. Deel door 1,21: €121 ÷ 1,21 = €100.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "stimulusAids": [],
      "feedback": { "explanationText": "De klant wil weten wat de elektricien exclusief BTW rekent. Bij 21% BTW deel je door 1,21: €121 ÷ 1,21 = €100. Controleer: €100 × 1,21 = €121 ✓.", "solutionSteps": ["21% BTW → deel door 1,21", "€121 ÷ 1,21 = €100", "Controleer: €100 × 1,21 = €121 ✓"], "distractorExplanations": { "0": "Goed! €121 ÷ 1,21 = €100.", "1": "Je trekt 21% van de inclusief-prijs af, maar de BTW was berekend over de exclusief-prijs. Deel door 1,21: €121 ÷ 1,21 = €100.", "2": "Bij 'exclusief BTW' reken je de BTW eruit, niet erbij. Deel door 1,21.", "3": "€21 is het percentage, niet het BTW-bedrag. Deel door 1,21: €121 ÷ 1,21 = €100." } }
    },
    {
      "id": "GELD-BTW-004", "familyId": "GELD-BTW", "module": "Geld", "tier": 15, "levelCode": "E8", "group": 8, "skill": "geld_toegepast", "subSkill": "geld_btw", "questionType": "multiple_choice",
      "question": "Een bakker koopt meel voor €175 exclusief BTW. Hoeveel BTW betaalt hij bij 21%?",
      "options": ["€36,75", "€21", "€138,25", "€211,75"], "correctAnswer": 0,
      "conceptId": "btw_amount_21pct", "variantIndex": 4, "citoDifficulty": 0.38, "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "BTW-FLAT-RATE", "optionIndex": 1, "label": "Denkt dat 21% altijd €21 is ongeacht bedrag" },
          { "id": "BTW-CONFUSE-REMAINDER", "optionIndex": 2, "label": "Geeft prijs-na-aftrek i.p.v. BTW-bedrag" },
          { "id": "BTW-CONFUSE-TOTAL", "optionIndex": 3, "label": "Geeft totaalprijs inclusief BTW i.p.v. alleen BTW" }
        ]
      },
      "supportAids": [{ "type": "rule", "data": { "title": "BTW-bedrag berekenen", "content": "Bereken 21% van €175: 0,21 × €175 = €36,75. De bakker betaalt €36,75 aan BTW.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "stimulusAids": [],
      "feedback": { "explanationText": "De bakker berekent de BTW: 21% van €175 = 0,21 × €175 = €36,75.", "solutionSteps": ["BTW = 21% van €175", "BTW = 0,21 × €175 = €36,75"], "distractorExplanations": { "0": "Goed! 21% van €175 = €36,75 aan BTW.", "1": "21% is niet altijd €21. Het hangt af van het bedrag: 0,21 × €175 = €36,75.", "2": "€138,25 is de prijs na aftrek (€175 − €36,75), maar de vraag is hoeveel BTW: €36,75.", "3": "€211,75 is de totaalprijs inclusief BTW (€175 + €36,75). De vraag is alleen hoeveel BTW: €36,75." } }
    },
    {
      "id": "GELD-BTW-005", "familyId": "GELD-BTW", "module": "Geld", "tier": 15, "levelCode": "E8", "group": 8, "skill": "geld_toegepast", "subSkill": "geld_btw", "questionType": "multiple_choice",
      "question": "Een restauranthouder betaalt €54,50 inclusief 9% BTW voor ingrediënten. Wat is de prijs exclusief BTW?",
      "options": ["€50", "€49,60", "€59,40", "€45,50"], "correctAnswer": 0,
      "conceptId": "btw_incl_to_excl_9pct", "variantIndex": 5, "citoDifficulty": 0.42, "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "BTW-SUBTRACT-FROM-INCL", "optionIndex": 1, "label": "Trekt 9% van inclusief-prijs af i.p.v. delen door 1,09" },
          { "id": "BTW-ADD-INSTEAD", "optionIndex": 2, "label": "Telt BTW erbij in plaats van eruit te rekenen" },
          { "id": "BTW-SUBTRACT-FLAT", "optionIndex": 3, "label": "Trekt €9 af als vast bedrag" }
        ]
      },
      "supportAids": [{ "type": "rule", "data": { "title": "BTW terugrekenen (9%)", "content": "Bij 9% BTW is de prijs inclusief BTW 109% van de oorspronkelijke prijs. Deel door 1,09: €54,50 ÷ 1,09 = €50.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "stimulusAids": [],
      "feedback": { "explanationText": "De restauranthouder deelt door 1,09: €54,50 ÷ 1,09 = €50. Controleer: €50 × 1,09 = €54,50 ✓.", "solutionSteps": ["9% BTW → deel door 1,09", "€54,50 ÷ 1,09 = €50", "Controleer: €50 × 1,09 = €54,50 ✓"], "distractorExplanations": { "0": "Goed! €54,50 ÷ 1,09 = €50.", "1": "Je trekt 9% van de inclusief-prijs af, maar de BTW was berekend over de exclusief-prijs. Deel door 1,09.", "2": "Bij 'exclusief BTW' reken je de BTW eruit, niet erbij. Deel door 1,09.", "3": "€9 is het percentage, niet het BTW-bedrag. Deel door 1,09: €54,50 ÷ 1,09 = €50." } }
    },
    {
      "id": "GELD-BTW-006", "familyId": "GELD-BTW", "module": "Geld", "tier": 15, "levelCode": "E8", "group": 8, "skill": "geld_toegepast", "subSkill": "geld_btw", "questionType": "multiple_choice",
      "question": "Een schilder koopt verf voor €85 exclusief BTW. Met 21% BTW erbij, wat betaalt hij?",
      "options": ["€102,85", "€17,85", "€67,15", "€106"], "correctAnswer": 0,
      "conceptId": "btw_excl_to_incl_21pct_85", "variantIndex": 6, "citoDifficulty": 0.38, "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "BTW-ONLY-TAX", "optionIndex": 1, "label": "Geeft alleen het BTW-bedrag, niet de totaalprijs" },
          { "id": "BTW-SUBTRACT", "optionIndex": 2, "label": "Trekt BTW af in plaats van erbij op te tellen" },
          { "id": "BTW-FLAT-RATE", "optionIndex": 3, "label": "Interpreteert 21% als vast bedrag €21" }
        ]
      },
      "supportAids": [{ "type": "rule", "data": { "title": "BTW berekenen (21%)", "content": "Bereken eerst de BTW: 21% van €85 = 0,21 × €85 = €17,85. Tel de BTW bij de prijs: €85 + €17,85 = €102,85.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "stimulusAids": [],
      "feedback": { "explanationText": "De schilder berekent de prijs inclusief BTW: 21% van €85 = €17,85. Totaal: €85 + €17,85 = €102,85. Of sneller: €85 × 1,21 = €102,85.", "solutionSteps": ["BTW = 21% van €85 = 0,21 × €85 = €17,85", "Prijs inclusief = €85 + €17,85 = €102,85", "Of sneller: €85 × 1,21 = €102,85 ✓"], "distractorExplanations": { "0": "Goed! €85 + 21% BTW (€17,85) = €102,85.", "1": "€17,85 is alleen het BTW-bedrag. De schilder betaalt de prijs plus de BTW: €85 + €17,85 = €102,85.", "2": "Bij 'inclusief BTW' tel je de BTW erbij op, niet eraf. €85 + €17,85 = €102,85.", "3": "21% van €85 is €17,85, niet €21. Onthoud: 0,21 × €85 = €17,85." } }
    },
    {
      "id": "GELD-BTW-007", "familyId": "GELD-BTW", "module": "Geld", "tier": 15, "levelCode": "E8", "group": 8, "skill": "geld_toegepast", "subSkill": "geld_btw", "questionType": "multiple_choice",
      "question": "Een glazenwasser stuurt een rekening van €65 exclusief BTW. Hoeveel BTW betaalt de klant bij 21%?",
      "options": ["€13,65", "€21", "€51,35", "€78,65"], "correctAnswer": 0,
      "conceptId": "btw_amount_21pct_65", "variantIndex": 7, "citoDifficulty": 0.37, "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "BTW-FLAT-RATE", "optionIndex": 1, "label": "Denkt dat 21% altijd €21 is" },
          { "id": "BTW-CONFUSE-REMAINDER", "optionIndex": 2, "label": "Geeft prijs-na-aftrek i.p.v. BTW-bedrag" },
          { "id": "BTW-CONFUSE-TOTAL", "optionIndex": 3, "label": "Geeft totaalprijs inclusief BTW i.p.v. alleen BTW" }
        ]
      },
      "supportAids": [{ "type": "rule", "data": { "title": "BTW-bedrag berekenen", "content": "Bereken 21% van €65: 0,21 × €65 = €13,65. De klant betaalt €13,65 aan BTW.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "stimulusAids": [],
      "feedback": { "explanationText": "De klant van de glazenwasser berekent de BTW: 21% van €65 = 0,21 × €65 = €13,65.", "solutionSteps": ["BTW = 21% van €65", "BTW = 0,21 × €65 = €13,65"], "distractorExplanations": { "0": "Goed! 21% van €65 = €13,65 aan BTW.", "1": "21% is niet altijd €21. Het hangt af van het bedrag: 0,21 × €65 = €13,65.", "2": "€51,35 is de prijs na aftrek, maar de vraag is hoeveel BTW: €13,65.", "3": "€78,65 is de totaalprijs inclusief BTW. De vraag is alleen hoeveel BTW: €13,65." } }
    },
    {
      "id": "GELD-BTW-008", "familyId": "GELD-BTW", "module": "Geld", "tier": 15, "levelCode": "E8", "group": 8, "skill": "geld_toegepast", "subSkill": "geld_btw", "questionType": "multiple_choice",
      "question": "Een meubelmaker verkoopt een kast voor €338,80 inclusief 21% BTW. Wat is de prijs exclusief BTW?",
      "options": ["€280", "€267,65", "€409,95", "€317,80"], "correctAnswer": 0,
      "conceptId": "btw_incl_to_excl_21pct_large", "variantIndex": 8, "citoDifficulty": 0.46, "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "BTW-SUBTRACT-FROM-INCL", "optionIndex": 1, "label": "Trekt 21% van inclusief-prijs af i.p.v. delen door 1,21" },
          { "id": "BTW-ADD-INSTEAD", "optionIndex": 2, "label": "Telt BTW erbij in plaats van eruit te rekenen" },
          { "id": "BTW-SUBTRACT-FLAT", "optionIndex": 3, "label": "Trekt €21 af als vast bedrag" }
        ]
      },
      "supportAids": [{ "type": "rule", "data": { "title": "BTW terugrekenen (21%)", "content": "Bij 21% BTW is de prijs inclusief BTW 121% van de oorspronkelijke prijs. Deel door 1,21: €338,80 ÷ 1,21 = €280.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "stimulusAids": [],
      "feedback": { "explanationText": "De klant wil weten wat de kast exclusief BTW kost. Bij 21% BTW deel je door 1,21: €338,80 ÷ 1,21 = €280. Controleer: €280 × 1,21 = €338,80 ✓.", "solutionSteps": ["21% BTW → deel door 1,21", "€338,80 ÷ 1,21 = €280", "Controleer: €280 × 1,21 = €338,80 ✓"], "distractorExplanations": { "0": "Goed! €338,80 ÷ 1,21 = €280.", "1": "Je trekt 21% van de inclusief-prijs af, maar de BTW was berekend over de exclusief-prijs. Deel door 1,21.", "2": "Bij 'exclusief BTW' reken je de BTW eruit, niet erbij. Deel door 1,21.", "3": "Je trekt €21 af, maar €21 is het percentage, niet het BTW-bedrag. Deel door 1,21." } }
    },
    {
      "id": "GELD-BTW-009", "familyId": "GELD-BTW", "module": "Geld", "tier": 15, "levelCode": "E8", "group": 8, "skill": "geld_toegepast", "subSkill": "geld_btw", "questionType": "multiple_choice",
      "question": "Een boekhandelaar koopt boeken voor €35 exclusief BTW. Met 9% BTW erbij, wat betaalt ze?",
      "options": ["€38,15", "€3,15", "€31,85", "€44"], "correctAnswer": 0,
      "conceptId": "btw_excl_to_incl_9pct_35", "variantIndex": 9, "citoDifficulty": 0.35, "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "BTW-ONLY-TAX", "optionIndex": 1, "label": "Geeft alleen het BTW-bedrag, niet de totaalprijs" },
          { "id": "BTW-SUBTRACT", "optionIndex": 2, "label": "Trekt BTW af in plaats van erbij op te tellen" },
          { "id": "BTW-FLAT-RATE", "optionIndex": 3, "label": "Interpreteert 9% als vast bedrag €9" }
        ]
      },
      "supportAids": [{ "type": "rule", "data": { "title": "BTW berekenen (9%)", "content": "Bereken eerst de BTW: 9% van €35 = 0,09 × €35 = €3,15. Tel de BTW bij de prijs: €35 + €3,15 = €38,15.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "stimulusAids": [],
      "feedback": { "explanationText": "De boekhandelaar berekent de prijs inclusief BTW: 9% van €35 = €3,15. Totaal: €35 + €3,15 = €38,15. Of sneller: €35 × 1,09 = €38,15.", "solutionSteps": ["BTW = 9% van €35 = 0,09 × €35 = €3,15", "Prijs inclusief = €35 + €3,15 = €38,15", "Of sneller: €35 × 1,09 = €38,15 ✓"], "distractorExplanations": { "0": "Goed! €35 + 9% BTW (€3,15) = €38,15.", "1": "€3,15 is alleen het BTW-bedrag. De boekhandelaar betaalt de prijs plus de BTW: €35 + €3,15 = €38,15.", "2": "Bij 'inclusief BTW' tel je de BTW erbij op, niet eraf. €35 + €3,15 = €38,15.", "3": "9% van €35 is €3,15, niet €9. Onthoud: 0,09 × €35 = €3,15." } }
    },
    {
      "id": "GELD-BTW-010", "familyId": "GELD-BTW", "module": "Geld", "tier": 15, "levelCode": "E8", "group": 8, "skill": "geld_toegepast", "subSkill": "geld_btw", "questionType": "multiple_choice",
      "question": "Een kapper betaalt €109 inclusief 9% BTW voor haarverzorgingsproducten. Wat is de prijs exclusief BTW?",
      "options": ["€100", "€99,20", "€118", "€90"], "correctAnswer": 0,
      "conceptId": "btw_incl_to_excl_9pct_109", "variantIndex": 10, "citoDifficulty": 0.44, "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "BTW-SUBTRACT-FROM-INCL", "optionIndex": 1, "label": "Trekt 9% van inclusief-prijs af i.p.v. delen door 1,09" },
          { "id": "BTW-ADD-INSTEAD", "optionIndex": 2, "label": "Telt BTW erbij in plaats van eruit te rekenen" },
          { "id": "BTW-WRONG-SUBTRACTION", "optionIndex": 3, "label": "Trekt willekeurig bedrag af" }
        ]
      },
      "supportAids": [{ "type": "rule", "data": { "title": "BTW terugrekenen (9%)", "content": "Bij 9% BTW is de prijs inclusief BTW 109% van de oorspronkelijke prijs. Deel door 1,09: €109 ÷ 1,09 = €100.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "stimulusAids": [],
      "feedback": { "explanationText": "De kapper deelt door 1,09: €109 ÷ 1,09 = €100. Controleer: €100 × 1,09 = €109 ✓.", "solutionSteps": ["9% BTW → deel door 1,09", "€109 ÷ 1,09 = €100", "Controleer: €100 × 1,09 = €109 ✓"], "distractorExplanations": { "0": "Goed! €109 ÷ 1,09 = €100.", "1": "Je trekt 9% van de inclusief-prijs af, maar de BTW was berekend over de exclusief-prijs. Deel door 1,09.", "2": "Bij 'exclusief BTW' reken je de BTW eruit, niet erbij. Deel door 1,09.", "3": "9% van €109 is niet €19. Deel door 1,09: €109 ÷ 1,09 = €100." } }
    },
    {
      "id": "GELD-BTW-011", "familyId": "GELD-BTW", "module": "Geld", "tier": 15, "levelCode": "E8", "group": 8, "skill": "geld_toegepast", "subSkill": "geld_btw", "questionType": "multiple_choice",
      "question": "Een ICT-bedrijf koopt een monitor voor €350 exclusief BTW. Hoeveel BTW betalen ze bij 21%?",
      "options": ["€73,50", "€21", "€276,50", "€423,50"], "correctAnswer": 0,
      "conceptId": "btw_amount_21pct_350", "variantIndex": 11, "citoDifficulty": 0.39, "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "BTW-FLAT-RATE", "optionIndex": 1, "label": "Denkt dat 21% altijd €21 is" },
          { "id": "BTW-CONFUSE-REMAINDER", "optionIndex": 2, "label": "Geeft prijs-na-aftrek i.p.v. BTW-bedrag" },
          { "id": "BTW-CONFUSE-TOTAL", "optionIndex": 3, "label": "Geeft totaalprijs inclusief BTW i.p.v. alleen BTW" }
        ]
      },
      "supportAids": [{ "type": "rule", "data": { "title": "BTW-bedrag berekenen", "content": "Bereken 21% van €350: 0,21 × €350 = €73,50. Het bedrijf betaalt €73,50 aan BTW.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "stimulusAids": [],
      "feedback": { "explanationText": "Het ICT-bedrijf berekent de BTW: 21% van €350 = 0,21 × €350 = €73,50.", "solutionSteps": ["BTW = 21% van €350", "BTW = 0,21 × €350 = €73,50"], "distractorExplanations": { "0": "Goed! 21% van €350 = €73,50 aan BTW.", "1": "21% is niet altijd €21. Het hangt af van het bedrag: 0,21 × €350 = €73,50.", "2": "€276,50 is de prijs na aftrek, maar de vraag is hoeveel BTW: €73,50.", "3": "€423,50 is de totaalprijs inclusief BTW. De vraag is alleen hoeveel BTW: €73,50." } }
    },
    {
      "id": "GELD-BTW-012", "familyId": "GELD-BTW", "module": "Geld", "tier": 15, "levelCode": "E8", "group": 8, "skill": "geld_toegepast", "subSkill": "geld_btw", "questionType": "multiple_choice",
      "question": "Een loodgieter stuurt een rekening van €87,20 inclusief 9% BTW. Wat is de prijs exclusief BTW?",
      "options": ["€80", "€79,35", "€95,05", "€78,20"], "correctAnswer": 0,
      "conceptId": "btw_incl_to_excl_9pct_87", "variantIndex": 12, "citoDifficulty": 0.48, "citoDiscrimination": 0.69,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "BTW-SUBTRACT-FROM-INCL", "optionIndex": 1, "label": "Trekt 9% van inclusief-prijs af i.p.v. delen door 1,09" },
          { "id": "BTW-ADD-INSTEAD", "optionIndex": 2, "label": "Telt BTW erbij in plaats van eruit te rekenen" },
          { "id": "BTW-SUBTRACT-FLAT", "optionIndex": 3, "label": "Trekt €9 af als vast bedrag" }
        ]
      },
      "supportAids": [{ "type": "rule", "data": { "title": "BTW terugrekenen (9%)", "content": "Bij 9% BTW is de prijs inclusief BTW 109% van de oorspronkelijke prijs. Deel door 1,09: €87,20 ÷ 1,09 = €80.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "stimulusAids": [],
      "feedback": { "explanationText": "De klant van de loodgieter deelt door 1,09: €87,20 ÷ 1,09 = €80. Controleer: €80 × 1,09 = €87,20 ✓.", "solutionSteps": ["9% BTW → deel door 1,09", "€87,20 ÷ 1,09 = €80", "Controleer: €80 × 1,09 = €87,20 ✓"], "distractorExplanations": { "0": "Goed! €87,20 ÷ 1,09 = €80.", "1": "Je trekt 9% van de inclusief-prijs af, maar de BTW was berekend over de exclusief-prijs. Deel door 1,09.", "2": "Bij 'exclusief BTW' reken je de BTW eruit, niet erbij. Deel door 1,09.", "3": "€9 is het percentage, niet het BTW-bedrag. Deel door 1,09." } }
    },
    {
      "id": "GELD-BTW-013",
      "familyId": "GELD-BTW",
      "module": "Geld",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "fill_in",
      "question": "Een schilder rekent €175 exclusief BTW. Hoeveel betaalt de klant inclusief 21% BTW? Typ het bedrag in euro's (bijv. 211,75).",
      "correctAnswer": "211,75",
      "data": {
        "acceptedAnswers": ["211,75", "€211,75", "211.75", "€211.75"],
        "placeholder": "bedrag inclusief BTW in €",
        "inputType": "number"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "BTW berekenen (21%)", "content": "Prijs inclusief 21% BTW = prijs × 1,21. Hier: €175 × 1,21 = €211,75.", "icon": "lightbulb" } }
      ],
      "conceptId": "btw_fill_in_excl_to_incl",
      "variantIndex": 13,
      "pedagogy": { "dok": 2 },
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De schilder berekent de prijs inclusief BTW: €175 × 1,21 = €211,75. Of: 21% van €175 = €36,75, dus €175 + €36,75 = €211,75.",
        "solutionSteps": [
          "BTW = 21% van €175 = €36,75",
          "Prijs inclusief = €175 + €36,75 = €211,75",
          "Of sneller: €175 × 1,21 = €211,75"
        ]
      }
    },
    {
      "id": "GELD-BTW-014",
      "familyId": "GELD-BTW",
      "module": "Geld",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "fill_in",
      "question": "Een factuur is €338,80 inclusief 21% BTW. Wat is het bedrag exclusief BTW? Typ het bedrag in euro's (bijv. 280).",
      "correctAnswer": "280",
      "data": {
        "acceptedAnswers": ["280", "€280", "280,00", "€280,00"],
        "placeholder": "bedrag exclusief BTW in €",
        "inputType": "number"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "BTW terugrekenen (21%)", "content": "Bij 21% BTW is de prijs inclusief 121% van het origineel. Deel door 1,21: €338,80 ÷ 1,21 = €280.", "icon": "lightbulb" } }
      ],
      "conceptId": "btw_fill_in_incl_to_excl",
      "variantIndex": 14,
      "pedagogy": { "dok": 3 },
      "citoDifficulty": 0.47,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "De prijs inclusief BTW (€338,80) is 121% van het bedrag exclusief. Terugrekenen: €338,80 ÷ 1,21 = €280. Controleer: €280 × 1,21 = €338,80 ✓.",
        "solutionSteps": [
          "121% = €338,80",
          "Deel door 1,21: €338,80 ÷ 1,21 = €280",
          "Controleer: €280 × 1,21 = €338,80 ✓"
        ]
      }
    },
    {
      "id": "GELD-BTW-015",
      "familyId": "GELD-BTW",
      "module": "Geld",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "step_solver",
      "question": "Een factuur is €60,50 inclusief 21% BTW. Reken stap voor stap terug naar het bedrag exclusief BTW.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "stepSolver": {
          "context": "",
          "steps": [
            {
              "prompt": "De prijs inclusief 21% BTW is 121% van het origineel. Welk percentage is dat? (100% + 21% = ...%)",
              "correctAnswer": "121",
              "acceptedAnswers": ["121", "121%", "121 %"],
              "hint": "Tel het BTW-percentage op bij 100%"
            },
            {
              "prompt": "Hoeveel is 1%? (€60,50 ÷ 121 = ...)",
              "correctAnswer": "0,50",
              "acceptedAnswers": ["0,50", "0.50", "€0,50", "0,5", "0.5"],
              "hint": "Deel de inclusief-prijs door 121"
            },
            {
              "prompt": "Wat is 100%? (het bedrag exclusief BTW in €)",
              "correctAnswer": "50",
              "acceptedAnswers": ["50", "€50", "50,00", "€50,00"],
              "hint": "Vermenigvuldig 1% met 100"
            }
          ],
          "showStepsProgressively": true
        }
      },
      "conceptId": "btw_incl_to_excl_step_solver",
      "variantIndex": 15,
      "pedagogy": { "dok": 3 },
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stappenplan BTW terugrekenen",
            "content": "Stap 1: Bepaal het percentage (100% + BTW%). Stap 2: Bereken 1% (inclusief-prijs ÷ percentage). Stap 3: Bereken 100% (1% × 100). Hier: 121% = €60,50, 1% = €0,50, 100% = €50.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De prijs inclusief 21% BTW is 121% van het origineel. Stap 1: 121% = €60,50. Stap 2: 1% = €60,50 ÷ 121 = €0,50. Stap 3: 100% = €0,50 × 100 = €50. Controleer: 21% van €50 = €10,50. €50 + €10,50 = €60,50 ✓",
        "solutionSteps": [
          "121% = €60,50 (de prijs inclusief BTW)",
          "1% = €60,50 ÷ 121 = €0,50",
          "100% = €0,50 × 100 = €50",
          "Controleer: 21% van €50 = €10,50. €50 + €10,50 = €60,50 ✓"
        ]
      }
    },
    {
      "id": "GELD-BTW-016",
      "familyId": "GELD-BTW",
      "module": "Geld",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_btw",
      "questionType": "true_false_series",
      "question": "Zijn deze beweringen over BTW waar of onwaar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "In Nederland zijn er twee BTW-tarieven: 9% (laag) en 21% (hoog).", "isTrue": true },
          { "text": "BTW wordt berekend over de prijs inclusief BTW.", "isTrue": false }
        ]
      },
      "conceptId": "btw_true_false_conceptual",
      "variantIndex": 16,
      "pedagogy": { "dok": 2 },
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW-basisregels",
            "content": "In Nederland zijn er twee BTW-tarieven: 9% (voor o.a. voedsel en boeken) en 21% (voor de meeste producten en diensten). BTW wordt altijd berekend over de prijs exclusief BTW (de basisprijs).",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Stelling 1: Waar — Nederland kent twee BTW-tarieven: het lage tarief van 9% (voor o.a. voedsel, boeken en medicijnen) en het hoge tarief van 21% (voor de meeste andere producten en diensten). Stelling 2: Onwaar — BTW wordt berekend over de prijs exclusief BTW (de basisprijs), niet over de prijs inclusief BTW.",
        "solutionSteps": [
          "Stelling 1: Waar — twee tarieven: 9% (laag) en 21% (hoog)",
          "Stelling 2: Onwaar — BTW wordt berekend over de prijs exclusief BTW, niet inclusief"
        ]
      }
    }
  ]
}